import { ENDPOINT_ROUTES, BASE_URL } from "./routes";
import $ from "jquery";

const OFFER_PRICES_URL = BASE_URL + ENDPOINT_ROUTES.offerPrices;
const GROUPS_URL = OFFER_PRICES_URL + "/groups";

const api = {
  listPrices: async () => {
    return new Promise((resolve) => {
      $.ajax({
        url: OFFER_PRICES_URL,
        type: "GET",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  createEmptyPrice: async (group) => {
    return new Promise((resolve) => {
      $.ajax({
        url: OFFER_PRICES_URL + "/createEmpty",
        type: "POST",
        contentType: "application/json; charset=UTF-8",
        data: JSON.stringify({ group }),
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  updatePrice: async (id, price) => {
    return new Promise((resolve) => {
      $.ajax({
        url: OFFER_PRICES_URL + "/" + id,
        type: "PUT",
        contentType: "application/json; charset=UTF-8",
        data: JSON.stringify(price),
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  updatePricePosition: async (id, position) => {
    return new Promise((resolve) => {
      $.ajax({
        url: OFFER_PRICES_URL + "/" + id + "/position",
        type: "PUT",
        contentType: "application/json; charset=UTF-8",
        data: JSON.stringify({ position }),
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  deletePrice: async (id) => {
    return new Promise((resolve) => {
      $.ajax({
        url: OFFER_PRICES_URL + "/" + id,
        type: "DELETE",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  listGroups: async () => {
    return new Promise((resolve) => {
      $.ajax({
        url: GROUPS_URL,
        type: "GET",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  createGroup: async (name) => {
    return new Promise((resolve) => {
      $.ajax({
        url: GROUPS_URL,
        type: "POST",
        contentType: "application/json; charset=UTF-8",
        data: JSON.stringify({ name }),
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  updateGroup: async (id, name) => {
    return new Promise((resolve) => {
      $.ajax({
        url: GROUPS_URL + "/" + id,
        type: "PUT",
        contentType: "application/json; charset=UTF-8",
        data: JSON.stringify({ name }),
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
};

const offerPricesApi = { api };

export default offerPricesApi;
